module.exports = __webpack_public_path__ + "img/2328.57f24e42.gif";